import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { HXMobileButton } from "./HXButton";
export const SkipWitnessButton = styled(HXMobileButton).attrs({
    secondary: true,
}) `
    ${(props) => props.isActive &&
    css `
            border-color: ${colors.navy_main};
            background-color: rgba(13, 39, 64, 0.04);
        `}
`;
